const UCSColors = {
    gray00: "#000000",
    gray01: "#222222",
    gray03: "#444444",
    gray04: "#717171",
    gray05: "#999999",
    gray07: "#CCCCCC",
    gray08: "#E7E7E7",
    gray09: "#F6F6F6",
    gray10: "#FFFFFF",
    green00: "#007A53",
    sageGreen02: "#468065",
    tertiaryEY00: "#916E28",
    tertiaryRR00: "#8E3D1C",
    error: "#EE2222",
};

export default UCSColors;
